export function getMemberInitials(
  firstName?: string | null,
  lastName?: string | null
): string {
  const first = firstName?.[0] ?? '';
  const last = lastName?.[0] ?? '';
  return (first + last).toUpperCase() || '?';
}

export function getInitialsFromFullName(name?: string | null): string {
  const [firstName, lastName] = (name ?? '').split(' ');
  return getMemberInitials(firstName, lastName);
}

export function getTeamInitial(name: string): string {
  return name.charAt(0).toUpperCase() || '?';
}
